<div class="request-sent">
  <div class="close" (click)="close()">
    <i class="material-icons">close</i>
  </div>
  <div class="wrapper">
    <svg class="balloon" height="73" width="56" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-label="RE/Max Balloon">
      <image x="0" y="0" height="73" width="56" attr.xlink:href="{{'/assets/BalloonLarge.svg' | staticp }}"/>
    </svg>
    <div class="inner-content">
      <div class="is-flex centered title">
        <div class="circle">
          <i class="material-icons">done</i>
        </div>
        <div class="sent">
          <b translate="contact.request-sent"></b>
        </div>
      </div>
      <div class="thank-you text-center" *ngIf="!isShareForm">

        {{'contact.thank-you' | translate: {name: nameToDisplay} }}
      </div>

      <div class="thank-you text-center" *ngIf="isShareForm">
          {{'contact.share-thank-you' | translate: {name: nameToDisplay} }}
        </div>
    </div>
  </div>
</div>
